import * as React from "react";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { addCrush, removeCrush } from "../redux/actions/crushActions";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";

export default function ProfileCard({ profile }) {
  const { profile: ownProfile } = useSelector((state) => state.ProfileDetails);
  const dispatch = useDispatch();
  return (
    <Paper className="cursor-pointer p-4  w-full">
      <div className="flex justify-between items-center">
        <Link
          to={`/profile/${profile.id}`}
          gutterBottom
          variant="h5"
          component="div">
          {profile.firstName + " " + profile.lastName}, {profile.age}
        </Link>
        {ownProfile?.crushOnThem?.map((x) => x._id).includes(profile._id) ? (
          <IconButton
            onClick={() => dispatch(removeCrush(profile._id))}
            size="small">
            <FavoriteIcon className="text-red-500" />
          </IconButton>
        ) : (
          <IconButton
            size="small"
            onClick={() => dispatch(addCrush(profile._id))}>
            <FavoriteBorderOutlinedIcon />
          </IconButton>
        )}
      </div>
      <Typography variant="body2" color="text.secondary">
        {profile.bio}
      </Typography>
    </Paper>
  );
}
